// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1wTo4","choiceBoxes":"toolbarselects_choiceBoxes__2vT6S","simpleField":"toolbarselects_simpleField__2FOBz"};